module.exports = __webpack_public_path__ + "static/media/bts_lalela_170710_022_small.5795532d.jpg";